import { useDispatch, useSelector } from "react-redux";
import StatsGraphIcon from "../../assets/icons/stats-graph_icon.svg";
import {
  AnalyticsTypeMap,
  StatsDropdownOptionsMap,
  last5StatType,
} from "../../constants";
import styles from "./StatsDropdownSelector.module.scss";
import { sendAnalyticsEvent } from "../../lib/postMessage";
import { FILTERS, OPEN } from "../../constants/analytics";

const StatsDropdownSelector = () => {
  const dispatch = useDispatch();
  const { prefetchedFilters, onboardingStep } = useSelector(
    (state) => state.filter
  );

  const handleDropdown = () => {
    dispatch({ type: "SET_ACTIVE_FILTER_VIEW", payload: "stats" });
    sendAnalyticsEvent({
      event: FILTERS,
      type: AnalyticsTypeMap.get("stats") ?? "Stats",
      action: OPEN,
    });
  };

  const filterType = prefetchedFilters.stats ?? last5StatType;

  return (
    <button
      className={`${styles.statsDropdownSelector} ${
        onboardingStep === 1 ? styles["statsDropdownSelector--highlighted"] : ""
      }`}
      type="button"
      aria-label="stats-dropdown-selector"
      onClick={() => handleDropdown()}
    >
      <img src={StatsGraphIcon} alt="Stats Graph" />
      {StatsDropdownOptionsMap.get(filterType)}{" "}
    </button>
  );
};

export default StatsDropdownSelector;
